import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-thirthyeighty-upload',
    templateUrl: './thirthyeighty-upload.component.html',
    styleUrls: ['./thirthyeighty-upload.component.css'],
    standalone: false
})
export class ThirthyeightyUploadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
